const Service = require("../utils/Service");
const BookingDate = require("../utils/BookingDate");
const DateNoTz = require("../utils/DateNoTz");
const BookingDatesMixin = {
    data() {
        return {
            woStatusRanks: [],
            allWoiWasteTypes: null,
            settingsHash: null
        };
    },
    computed: {
        availableBookingDatesOfAddress() {
            return this.$store.getters.GET_AVAILABLE_BOOKING_DATES_OF_ADDRESS
                .list;
        },
        selectedService() {
            var bookingState = this.$store.getters.GET_BOOKING_STATE;
            return bookingState ? bookingState.selectedService : null;
        },
        serverDateString() {
            return this.$store.getters.GET_SERVER_DATE.payload;
        }
    },
    mounted() {},
    methods: {
        getBookingDatesOfWasteStream({ wasteStreamApi, parentStreamApi }) {
            var bookingDates = this.availableBookingDatesOfAddress;

            bookingDates = this.filterBookingDatesWithZeroAvailability(
                bookingDates
            );
            bookingDates = this.filterBookingDatesByService(
                bookingDates,
                this.selectedService
            );
            bookingDates = this.filterBookingDatesByWasteStream(bookingDates, {
                wasteStreamApi,
                parentStreamApi
            });

            return bookingDates;
        },
        filterBookingDatesWithZeroAvailability(bookingDates) {
            return bookingDates.filter(bookingDate => {
                let availableBookings = bookingDate.availableBookings;
                availableBookings =
                    typeof availableBookings === `string`
                        ? parseInt(availableBookings)
                        : availableBookings;
                return availableBookings > 0;
            });
        },
        filterBookingDatesByService(bookingDates, serviceData) {
            var service = new Service(
                serviceData,
                this.serverDateString,
                this.serverDateString
            );
            return service.deriveAvailableBookingDates(bookingDates);
        },
        filterBookingDatesByWasteStream(
            bookingDates,
            { wasteStreamApi, parentStreamApi }
        ) {
            return bookingDates.filter(bookingDate => {
                var bookingObj = new BookingDate(bookingDate);
                var hasWasteStream = bookingObj.hasWasteStreamApiValue(
                    wasteStreamApi
                );
                var hasParentStream = parentStreamApi
                    ? bookingObj.hasWasteStreamApiValue(parentStreamApi)
                    : false;
                return hasWasteStream || hasParentStream;
            });
        },
        filterBookingDatesByWasteStreamApis(bookingDates = [], wasteStreamApiList = []) {
            /**
            * Stry: RP-109
            * Date: 2021-04-16
            * Auth: Joseph Ricohermoso
            * Desc: The array list sometimes contained undefined value. We'll get rid of them here
            */
            wasteStreamApiList = wasteStreamApiList.filter(w => w);
            
            if(wasteStreamApiList.length == 0){
                return []
            }

            /*
                Stry: [RP-93] DEFECT - Available date not displaying
                Date: 2021-04-07
                Auth: Franco Mapua
            */

            // --- Create a booking date map to consolidate same dates 
            var bookingDateMap = {}
            bookingDates.forEach(bookingDate => {
                if(!bookingDateMap[bookingDate.date]){
                    bookingDateMap[bookingDate.date] = {
                        ...bookingDate
                    }
                    delete bookingDateMap[bookingDate.date].availableBookings
                    delete bookingDateMap[bookingDate.date].bookingLimit
                    delete bookingDateMap[bookingDate.date].wasteStreams

                    bookingDateMap[bookingDate.date].wasteStreamList = []
                }

                bookingDateMap[bookingDate.date].wasteStreamList.push({
                    availableBookings : bookingDate.availableBookings,
                    bookingLimit : bookingDate.bookingLimit,
                    wasteStreams : bookingDate.wasteStreams,
                })
            })

            var filteredBookingDates = bookingDates.filter(bookingDate => {
                // --- Get the booking date from the map
                var mapItem = bookingDateMap[bookingDate.date]
                if(!mapItem) return false; // This shouldn't happen, but you never know

                var hasWasteStream = wasteStreamApiList.every(wasteStreamApiValue =>{
                    var wasteStreamApiLowcase = wasteStreamApiValue.toLowerCase().replace(/ g/, "")
                    return mapItem.wasteStreamList.some(mapItemWasteStreamObj => {
                        if(mapItemWasteStreamObj.availableBookings <= 0) return false
                        else return mapItemWasteStreamObj.wasteStreams.some(wasteStreamObj => {
                            return wasteStreamObj.wasteStreamApiValue.toLowerCase().replace(/ g/, "") == wasteStreamApiLowcase
                        })
                    })
                })

                return hasWasteStream
            })

            return filteredBookingDates
        }
    }
};

module.exports = BookingDatesMixin;
